<template>
    <Widget title="User Data" :area="this.$props.area">
        <template v-if="hasData">
            <NameValue name="Username" :value="user.name" :link="`https://reddit.com/u/${user.name}`"/>
            <NameValue name="ID" :value="user.id"/>
            <NameValue name="Verified" :value="user.has_verified_email"/>
            <NameValue name="Gold" :value="user.is_gold"/>
            <NameValue name="Mod" :value="user.is_mod"/>
            <NameValue name="Since" :value="since_date"/>
            <NameValue name="For" :value="for_date"/>
        </template>
    </Widget>
</template>

<script>
    import Widget from "../Widget";
    import {mapGetters} from "vuex";
    import NameValue from "../NameValue";
    import * as moment from "moment";

    export default {
        components: {NameValue, Widget},
        props: {area: String},
        computed: {
            ...mapGetters(['user', 'allPosts', 'comments', 'submissions']),
            hasData(){
                return this.user !== null;
            },
            since_date() {
                return moment.unix(this.user.created_utc).format('YYYY-MM-DD HH:mm');
            },
            for_date() {
                return moment.unix(this.user.created_utc).fromNow(true);
            }
        },
        methods: {
            open() {
                // this.$message.info('lol');
            }
        }
    }
</script>

<style scoped>

</style>